import { PaginationInput } from '@repo/ui/data-table'
import qs from 'qs'
import { useSearchParams } from 'react-router-dom'

export const useUrl = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const removeSearchParam = (key: string) => {
    setSearchParams((params) => {
      const newParams = new URLSearchParams(params)
      newParams.delete(key)
      return newParams.toString()
    })
  }

  const readSearchParam = <T>(key: string) => {
    return qs.parse(searchParams.toString(), { ignoreQueryPrefix: true })[key] as T
  }

  const readPage = () => {
    const page = readSearchParam<string>('page')
    if (page) return parseInt(page) - 1
  }

  const readLimit = () => {
    const limit = readSearchParam<string>('limit')
    if (limit) return parseInt(limit)
  }

  const readSortBy = () => {
    const sortBy = readSearchParam<string>('sortBy')
    // sortBy format: "field:asc" or "field:desc"
    if (sortBy) {
      const [field, order] = sortBy.split(':')
      return { field, order }
    }
  }

  const pushPagination = (input: PaginationInput & { search: string }) => {
    const { pageIndex, pageSize, sorting, search } = input

    setSearchParams((params) => {
      const newParams = new URLSearchParams(params)
      newParams.set('page', (pageIndex + 1).toString())
      newParams.set('limit', pageSize.toString())
      if (sorting?.length) {
        const sortBy = sorting[0]
        newParams.set('sortBy', `${sortBy.id}:${sortBy.desc ? 'desc' : 'asc'}`)
      } else newParams.delete('sortBy')
      if (!search) newParams.delete('q')
      else newParams.set('q', search)
      return newParams.toString()
    })
  }

  const readPagination = () => {
    return {
      page: readPage(),
      limit: readLimit(),
      sortBy: readSortBy(),
      q: readSearchParam<string>('q')
    }
  }

  return {
    searchParams,
    pushPagination,
    readPagination,
    removeSearchParam,
    readSearchParam,
    setSearchParams
  }
}
